import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_CONSTANTS } from "../constant/API-constants";

@Injectable({
  providedIn: "root",
})
export class ProvideMenuService {
  constructor(private http: HttpClient) {}
  public getMenus(): any {
    return this.http.get(`${API_CONSTANTS.MODULE_LIST}`);
  }
  public getFeatures(): any {
    return this.http.get(`${API_CONSTANTS.FEATURE_LIST}`);
  }
  public mapPermissions(featureMenus) {
    return this.http.post(`${API_CONSTANTS.MAP_PERMISSION}`, featureMenus);
  }
  public enableMenus(menus) {
    return this.http.post(`${API_CONSTANTS.ENABLE_MENUS}`, menus);
  }
  public mappedPermissions() {
    return this.http.get(`${API_CONSTANTS.PERMISSION_MAP}`);
  }
}
